import { Action } from '@ngrx/store';

export enum ECalendarsOperationType {
    ADD,
    MODIFY,
    RESET
}

export enum ECalendarsActions {
    CalendarsList = '[Calendars list] get list of available calendars',
    CalendarsListSuccess = '[Calendars list success] get list of available calendars success',
    GetBaseCalendar = '[Calendars base] get base calendar',
    GetBaseCalendarSuccess = '[Calendars base success] get base calendar success',
    GetUserCalendar = '[Calendars user] get user calendar',
    GetUserCalendarSuccess = '[Calendars user success] get user calendar success',
    SetSelectedUser = '[Calendars user] Set selected user calendar',
    SetBaseCalendarUser = '[Calendars user] Set base calendar by user',
    UpdateBaseCalendarUser = '[Calendars user] Update base calendar by user',
    UpdateBaseCalendarUserSuccess = '[Calendars user] Update base calendar by user success',
    AddWorkingTimeSchema = '[Calendars user] Add new calendars range',
    ModifyWorkingTimeSchema = '[Calendars user] Modify a calendars range',
    ResetWorkingTimeSchema = '[Calendars user] Reset a range of days',
    ChangesOverWorkingTimeSchemaSuccess = '[Calendars user] Operation successfully',
    DeleteWorkingTimeSchemaRange = '[Calendars user] Delete calendars range',
    UpdateCustomCalendar = '[Calendars user] Update custom calendar',
    UpdateCustomCalendarSuccess = '[Calendars user] Update custom calendar success',
    SetCustomCalendar = '[Calendars user] Set custom calendar',
    SetInitialBaseCalendarUser = '[Calendars user] Set initial base calendar by user',
    SetInitialCustomCalendarUser = '[Calendars user] Set initial custom calendar by user',
    ResetState = '[Calendars user] Reset state to initial'
}


export class CalendarsList implements Action {
    public readonly type = ECalendarsActions.CalendarsList;
}

export class CalendarsListSuccess implements Action {
    public readonly type = ECalendarsActions.CalendarsListSuccess;
    constructor(public payload: IBaseCalendar[]) { }
}

export class GetBaseCalendar implements Action {
    public readonly type = ECalendarsActions.GetBaseCalendar;
    constructor(public payload: string) { }
}

export class GetBaseCalendarSuccess implements Action {
    public readonly type = ECalendarsActions.GetBaseCalendarSuccess;
    constructor(public payload: IBaseCalendar) { }
}

export class GetUserCalendar implements Action {
    public readonly type = ECalendarsActions.GetUserCalendar;
    constructor(public payload?: number) { }
}

export class GetUserCalendarSuccess implements Action {
    public readonly type = ECalendarsActions.GetUserCalendarSuccess;
    constructor(public payload: IWorkingTimeSchema[]) { }
}

export class SetSelectedUser implements Action {
    public readonly type = ECalendarsActions.SetSelectedUser;
    constructor(public payload: ISpecificUser) { }
}

export class SetBaseCalendarUser implements Action {
    public readonly type = ECalendarsActions.SetBaseCalendarUser;
    constructor(public payload: IBaseCalendar) { }
}

export class UpdateBaseCalendarUser implements Action {
    public readonly type = ECalendarsActions.UpdateBaseCalendarUser;
    constructor(public idUser: number, public idWorkingTimeSchema: number) { }
}

export class UpdateBaseCalendarUserSuccess implements Action {
    public readonly type = ECalendarsActions.UpdateBaseCalendarUserSuccess;
    constructor() { }
}


export class AddWorkingTimeSchema implements Action {
    public readonly type = ECalendarsActions.AddWorkingTimeSchema;
    constructor(public workingTimeSchema: IWorkingTimeSchema, public operation = ECalendarsOperationType.ADD) { }
}

export class ChangesOverWorkingTimeSchemaSuccess implements Action {
    public readonly type = ECalendarsActions.ChangesOverWorkingTimeSchemaSuccess;
    constructor(public payload: IWorkingTimeSchema[]) { }
}

export class ModifyWorkingTimeSchema implements Action {
    public readonly type = ECalendarsActions.ModifyWorkingTimeSchema;
    constructor(public workingTimeSchema: IWorkingTimeSchema, public operation = ECalendarsOperationType.MODIFY) { }
}

export class ResetWorkingTimeSchema implements Action {
    public readonly type = ECalendarsActions.ResetWorkingTimeSchema;
    constructor(public workingTimeSchema: IWorkingTimeSchema, public operation = ECalendarsOperationType.RESET) { }
}

export class DeleteWorkingTimeSchemaRange implements Action {
    public readonly type = ECalendarsActions.DeleteWorkingTimeSchemaRange;
    constructor(public payload: IWorkingTimeSchema) { }
}

export class UpdateCustomCalendar implements Action {
    public readonly type = ECalendarsActions.UpdateCustomCalendar;
    constructor() { }
}

export class UpdateCustomCalendarSuccess implements Action {
    public readonly type = ECalendarsActions.UpdateCustomCalendarSuccess;
    constructor() { }
}

export class SetCustomCalendar implements Action {
    public readonly type = ECalendarsActions.SetCustomCalendar;
    constructor(public payload: IWorkingTimeSchema[]) { }
}

export class SetInitialBaseCalendarUser implements Action {
    public readonly type = ECalendarsActions.SetInitialBaseCalendarUser;
    constructor(public payload: IBaseCalendar) { }
}

export class SetInitialCustomCalendarUser implements Action {
    public readonly type = ECalendarsActions.SetInitialCustomCalendarUser;
    constructor(public payload: IWorkingTimeSchema[]) { }
}

export class ResetState implements Action {
    public readonly type = ECalendarsActions.ResetState;
    constructor() { }
}


export type WorkingTimeSchemaActions = CalendarsList |
    CalendarsListSuccess |
    GetBaseCalendar |
    GetBaseCalendarSuccess |
    GetUserCalendar |
    GetUserCalendarSuccess |
    SetSelectedUser |
    SetBaseCalendarUser |
    UpdateBaseCalendarUser |
    UpdateBaseCalendarUserSuccess |
    AddWorkingTimeSchema |
    ModifyWorkingTimeSchema |
    ResetWorkingTimeSchema |
    ChangesOverWorkingTimeSchemaSuccess |
    DeleteWorkingTimeSchemaRange |
    SetCustomCalendar |
    SetInitialBaseCalendarUser |
    SetInitialCustomCalendarUser |
    UpdateCustomCalendar |
    ResetState |
    UpdateCustomCalendarSuccess;
